// extracted by mini-css-extract-plugin
export var changeIcon = "_6k-4";
export var container = "_6k-0";
export var divider = "_6k-7";
export var externalLinkIcon = "_6k-1";
export var green = "_6k-5";
export var helpCircleIcon = "_6k-3";
export var iconButton = "_6k-2";
export var red = "_6k-6";